import { useState } from 'react';
import { PortfolioGrid } from './PortfolioGrid.js';
import { ProjectAFunds } from './ProjectAFunds.js';

/**
 * Project A's own side of the list: the companies it holds, who sat beside it
 * in each and the rounds they raised, and its own funds. The funds page reads
 * the same co-investments from the other side.
 */
type Tab = 'companies' | 'funds';

const TAB_KEY = 'nemo.portfolio.tab';

function readTab(): Tab {
  try {
    return window.localStorage.getItem(TAB_KEY) === 'funds' ? 'funds' : 'companies';
  } catch {
    // A private window or a cleared store is simply no preference.
    return 'companies';
  }
}

function writeTab(tab: Tab): void {
  try {
    window.localStorage.setItem(TAB_KEY, tab);
  } catch {
    // Nothing here is worth failing a click over.
  }
}

export function PortfolioPage(): React.JSX.Element {
  const [tab, setTab] = useState<Tab>(() => readTab());

  function choose(next: Tab): void {
    setTab(next);
    writeTab(next);
  }

  return (
    <div className="page">
      <div className="tabs" role="tablist" aria-label="Which part of the portfolio">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'companies'}
          className={tab === 'companies' ? 'tab active' : 'tab'}
          onClick={() => choose('companies')}
        >
          Portfolio companies
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'funds'}
          className={tab === 'funds' ? 'tab active' : 'tab'}
          onClick={() => choose('funds')}
        >
          Project A funds
        </button>
      </div>

      {tab === 'companies' ? <PortfolioGrid /> : <ProjectAFunds />}
    </div>
  );
}
